const TESTIMONIALS: readonly {
  quote: string;
  name: string;
  initials: string;
  role: string;
}[] = [
  {
    quote:
      "Pasamos de mandarle al contador planillas sueltas a entregarle un Excel firmado con los asientos del mes ya derivados. El cierre del año pasado lo hicimos en una semana, no en un mes.",
    name: "Matías Rodríguez",
    initials: "MR",
    role: "Productor lechero, Valle Central",
  },
  {
    quote:
      "Por primera vez vemos cuánto realmente nos cuesta criar cada vaquilla. Dejamos de tirar todo a gasto y empezamos a registrar el activo biológico como corresponde. El banco notó el cambio en los estados financieros.",
    name: "Ana Suárez",
    initials: "AS",
    role: "Administradora, Cooperativa Lechera",
  },
];

export function LandingTestimonials() {
  return (
    <section
      id="customers"
      className="relative z-10 overflow-hidden border-white/[0.06] border-b bg-[#050A08] px-6 py-32 md:px-12"
    >
      <div className="relative z-10 mx-auto mb-20 max-w-4xl text-center">
        <h2 className="js-mask-reveal font-medium text-2xl text-white tracking-tight">
          Productores que despertaron las cuentas dormidas.
        </h2>
      </div>

      <div className="relative z-10 mx-auto grid max-w-5xl grid-cols-1 gap-16 md:grid-cols-2 md:gap-24">
        <div
          aria-hidden
          className="-translate-x-1/2 pointer-events-none absolute top-0 bottom-0 left-1/2 hidden w-px bg-white/[0.05] md:block"
        />

        {TESTIMONIALS.map((t) => (
          <figure key={t.name} className="scroll-fade flex flex-col items-center text-center">
            <blockquote className="mb-10 text-lg text-neutral-300 leading-relaxed">
              “{t.quote}”
            </blockquote>
            <figcaption className="flex flex-col items-center gap-3">
              <div className="rounded-full bg-gradient-to-b from-primary-500/40 to-transparent p-[1px]">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-panel font-medium text-sm text-white">
                  {t.initials}
                </div>
              </div>
              <div>
                <div className="font-medium text-sm text-white">{t.name}</div>
                <div className="text-neutral-500 text-xs">{t.role}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
